<template>
  <div v-if="isAdmin">
    <div
      class="tw:max-w-md"
      v-if="selectedReasonObject !== null && (selectedReasonObject?.id === 9 || selectedReasonObject?.id === 10)"
    >
      <p class="tw:text-gray-800 tw:mb-6">{{ $t('rc_pause_flow_pause_header') }}</p>
      <SmartHintsContainer
        :isItemNetCPAEligible="isItemNetCPAEligible"
        :selectedReasonObject="selectedReasonObject"
        @toggleChangeCampaignModal="toggleChangeCampaignModal"
      />
    </div>
    <div v-else class="tw:max-w-md tw:mx-auto tw:space-y-8 tw:pb-6">
      <RadioOption
        :selectedValue="pauseType"
        @select="updatePauseType"
        value="temporary"
        :label="$t('rc_pause_calendar_header')"
      >
        <div>
          <p class="tw:text-xs tw:mb-4" v-html="$t('rc_pause_info_text')" />
          <Calendar @setResumeDate="setResumeDate" :resumeDate="resumeDate" />
          <div class="required-info tw:text-xs tw:text-gray-700 tw:mt-4" v-html="$t('rc_pause_required_info')" />
        </div>
      </RadioOption>

      <RadioOption
        :selectedValue="pauseType"
        @select="updatePauseType"
        value="permanent"
        :label="$t('rc_set_campaign_inactive')"
      >
        <div>
          <p
            class="tw:text-xs"
            :class="{ 'tw:mb-4': selectedReasonObject !== null && selectedReasonObject?.id !== 11 }"
            v-html="$t('rc_campaign_inactive_info_text')"
          />
          <SmartHintsContainer
            :isItemNetCPAEligible="isItemNetCPAEligible"
            :selectedReasonObject="selectedReasonObject"
            @toggleChangeCampaignModal="toggleChangeCampaignModal"
          />
        </div>
      </RadioOption>
    </div>
  </div>
  <div v-else>
    <p v-html="$t(resumeDate === null ? 'rc_pause_admin_info' : 'rc_campaign_change_admin_info')" />
  </div>
</template>

<script setup>
import Calendar from '@/components/rateConnect/pauseFlow/cpa/Calendar.vue'
import RadioOption from '@/components/rateConnect/pauseFlow/cpa/RadioOption.vue'
import SmartHintsContainer from '@/components/rateConnect/pauseFlow/SmartHintsContainer.vue'

defineProps({
  pauseType: String,
  isItemNetCPAEligible: Boolean,
  selectedReasonObject: [Object, null],
  resumeDate: [Date, null],
  isAdmin: Boolean,
})

const emit = defineEmits(['updatePauseType', 'toggleChangeCampaignModal', 'setResumeDate'])
const updatePauseType = value => emit('updatePauseType', value)
const toggleChangeCampaignModal = value => emit('toggleChangeCampaignModal', value)
const setResumeDate = value => emit('setResumeDate', value)
</script>
